import { render } from "./ProsesFinance.vue?vue&type=template&id=b3539c56"
import script from "./ProsesFinance.vue?vue&type=script&lang=js"
export * from "./ProsesFinance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__